<template>

  <div class="orderContainer">
    <div class="orderTop">
      <el-menu :default-active="orderActiveIndex" class="orderMenu" mode="horizontal" @select="handleSelect">
        <el-menu-item class="orderElMenu" index="orderHistory">{{ $t("web.order.name.history") }}</el-menu-item>
      </el-menu>
      <el-button class="helpCenter" @click="openHelpCenter">{{ this.$t('web.pop.help_center') }}</el-button>
    </div>
    <OrderHistory/>
    <div class="goods-content" v-if="carListShow">
      <carList></carList>
    </div>
    <PicPop v-if="picPopFlag"/>
  </div>
</template>
<script>
import {mapState} from "vuex";

const {defineAsyncComponent} = Vue;

export default {
  name: "Order",
  components: {
    PicPop: defineAsyncComponent(() => import(/* webpackChunkName: "picPop" */ '@/components/PicPop.vue')),
    CarList: defineAsyncComponent(() => import(/* webpackChunkName: "carList" */ '@/components/CarList.vue')),
    OrderHistory: defineAsyncComponent(() => import(/* webpackChunkName: "orderHistory" */ '@/components/OrderHistory.vue'))
  },
  data() {
    return {}
  },
  created() {
    // this.updateLanguage();
  },
  computed: {
    ...mapState(['carListShow', 'orderActiveIndex']),
    ...mapState('order', ['picPopFlag']),
  },
  methods: {
    handleSelect(key) {
      this.$store.dispatch("updateOrderActiveIndex", key);
    },
    openHelpCenter() {
      window.open('https://familypro.crisp.help/', '_blank');
    }

  }
}

</script>
<style scoped>

.orderContainer {
  width: 100%;
  min-height: 100vh;
  height: auto !important;
  text-align: center;
  margin: auto;
  -ms-overflow-style: none; /* IE 10+ */
  scrollbar-width: none; /* Firefox */
  margin-top: 0vh !important;
}

.orderContainer :deep(.orderMenu) {
  /* height: 5vh !important; */
  flex: 9;
  width: 65% !important;
  margin: auto !important;
  border: none;
  margin-bottom: 20px;
  font-family: 'Alibaba Sans', sans-serif !important;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0px;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3D3D3D;
  margin-left: 0 !important;
  padding: 0 !important;
}

.orderElMenu {
  font-size: 16px !important;
}

.orderTop {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 80% !important;
  margin: auto !important;
}

.helpCenter {
  flex: 1;
  border: unset;
  margin: auto !important;
  color: #FB713C !important;
  border-bottom: 1px solid #FB713C !important;
}

.helpCenter:hover {
  color: #FB713C !important;
  background-color: transparent !important;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 2px solid #FB713C !important;
  color: #FB713C !important;
}

.el-menu--horizontal > .el-menu-item.is-active:hover {
  background-color: #FFFFFF !important;
}

.el-menu--horizontal > .el-menu-item:hover {
  background-color: #FFFFFF !important;
  color: #FB713C !important;
}

.el-menu--horizontal > .el-menu-item {
  padding: 0 15px 0 0 !important;
}

.goods-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(128, 128, 128, 0.5); /* 背景透明 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999 !important;
}

.goods-content * {
  opacity: 1; /* 子元素不透明 */
}

.goods-content > :not(.background) {
  opacity: 1;
}

.netflixPopContainer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: transparent;

  display: flex;
  flex-direction: row;
  justify-content: center;
}

.cahtGPTPopContainer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: transparent;

  display: flex;
  flex-direction: row;
  justify-content: center;
}

@media (max-width: 768px) {
  .orderContainer {
    width: 100%;
    margin-top: 0vh !important;
  }

  .orderTop {
    width: 90% !important;
  }

  .orderContainer :deep(.orderMenu) {
    width: 100% !important;
  }

  .goods-content {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(128, 128, 128, 0.5); /* 背景透明 */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .goods-content * {
    opacity: 1; /* 子元素不透明 */
  }

  .goods-content > :not(.background) {
    opacity: 1;
  }
}
</style>